<template>
  <div class="home page-home">
    <van-list class="list">
      <van-cell v-for="item in list" :key="item.id" @click="jump2list(item)">
        <ListItemCard :title="item.className" :img="item.imgUrl">
          <template #desc>
            <div class="desc">
              <span class="ell-2">{{ item.synopsis }}</span>
              <span>{{ item.visitTimes }}人正在学习</span>
            </div>
          </template>
        </ListItemCard>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import { encyclopediaClassesList } from '@/services';
import { getAdapter } from '@zyf2e/adapt';

export default {
  data() {
    return {
      list: [],
      params: {
        accessibilityType: ''
      }
    };
  },
  mounted() {
    const { accessibilityType } = this.$route.query || {};
    this.params.accessibilityType = parseInt(accessibilityType) || '';

    this.onLoad();
    const adapt = getAdapter();
    adapt.setTitle('健康百科');
  },
  methods: {
    // 这里不需要下拉加载
    async onLoad() {
      const res = await encyclopediaClassesList(this.params);
      this.list = res.dataList;
    },

    jump2list({ styleType, id, className }) {
      this.telescope.trackEvent({ trackId: 'zyxcx-click-firsthealthcategory', custom: { id, className } });

      const adapt = getAdapter();
      adapt.setTitle(className || '健康百科');

      let hashPath = '';

      if (styleType === 1) {
        hashPath = `course/list?classId=${id}`;
      } else if (styleType === 2) {
        hashPath = `graphic/list?parentId=${id}`;
      }

      const query = this.$route.query || {};

      if (query.isTabPage > 0) {
        const url = `/pages/common/webview?url=${encodeURIComponent(window.location.href.split('?')[0] + hashPath)}`;

        window.wx.miniProgram.navigateTo({
          url
        });
      } else {
        this.$router.push('/' + hashPath);
      }
    }
  }
};
</script>

<style lang="less" scoped></style>
<style lang="less">
.home.page-home {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;

  .list {
    flex: 1;
    .van-cell {
      padding: 20px 16px;
    }
  }

  .list-item-card {
    .left img {
      width: 78px;
      height: 96px;
    }
    .right {
      padding-top: 6px;
    }
  }

  @media (min-width: 768px) {
    .list {
      padding: 24px;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 20px;
      align-content: start;

      .van-cell {
        padding: 20px 22px;
        margin: 0;
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
      }

      .van-cell::after {
        display: none;
      }
    }

    .list-item-card {
      .left img {
        width: 100px;
        height: 124px;
        border-radius: 6px;
      }
      .right {
        padding-top: 4px;
        .title {
          font-size: 17px;
          line-height: 24px;
        }
      }
      .desc span {
        font-size: 13px;
      }
    }
  }

  @media (min-width: 1100px) {
    .list {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 24px;
    }
  }
}
</style>
